import { AuthService } from '../../auth.service';
import { Injectable } from '@angular/core';
import { LogisticsService } from '../../logistics.service';
import { StudyReportBatchEditInfo, StudyReportBatch, StudyReportBatchItemInfo } from '../../../model/logistics/study-report/index';

@Injectable()
export class StudyReportSendWizardService {

  private studyReportBatchEditInfo: StudyReportBatchEditInfo;
  private isReceive = false;

  constructor(private logisticsService: LogisticsService
    , private authService: AuthService) {
  }

  async initialize(studyReportBatchId?: number, isReceive?: boolean) {
    this.isReceive = isReceive;
    this.studyReportBatchEditInfo = await this.logisticsService.getStudyReportBatchEditInfo(this.authService.getSectorId()
      , studyReportBatchId);
  }

  isReceiving(): boolean { return this.isReceive; }

  async studyReportBatchSend(): Promise<boolean> {
    this.studyReportBatchEditInfo.SectorId = this.authService.getSectorId();
    return await this.logisticsService.studyReportBatchSend(this.studyReportBatchEditInfo);
  }

  async studyReportBatchUpdate(): Promise<boolean> {
    this.studyReportBatchEditInfo.SectorId = this.authService.getSectorId();
    return await this.logisticsService.studyReportBatchUpdate(this.studyReportBatchEditInfo);
  }

  async studyReportBatchReceive(): Promise<boolean> {
    this.studyReportBatchEditInfo.SectorId = this.authService.getSectorId();
    return await this.logisticsService.studyReportBatchReceive(this.studyReportBatchEditInfo);
  }

  async addProtocol(protocol: string): Promise<StudyReportBatchItemInfo[]> {
    this.studyReportBatchEditInfo.NewProtocol = protocol;
    this.studyReportBatchEditInfo.StudyReportBatchItems =
      await this.logisticsService.studyReportBatchItemAddProtocoloSend(this.studyReportBatchEditInfo);
    return this.studyReportBatchEditInfo.StudyReportBatchItems;
  }

  removeStudyReportBatchItem(index: number): void {
    const item = this.studyReportBatchEditInfo.StudyReportBatchItems[index];
    this.studyReportBatchEditInfo.StudyReportBatchItems.splice(index, 1);
    if (item.Id > 0) {
      if (!this.studyReportBatchEditInfo.StudyReportBatchItems) {
        this.studyReportBatchEditInfo.DeletedStudyReportBatchItems = [];
      }
      this.studyReportBatchEditInfo.DeletedStudyReportBatchItems.push(item);
    }
  }

  setStudyReportBatch(studyReportBatch: StudyReportBatch): void {
    this.studyReportBatchEditInfo.StudyReportBatch = studyReportBatch;
  }

  getStudyReportBatchEditInfo(): StudyReportBatchEditInfo {
    return this.studyReportBatchEditInfo;
  }

  getStudyReportBatchItems(): StudyReportBatchItemInfo[] {
    return this.studyReportBatchEditInfo.StudyReportBatchItems;
  }
}
